import { getSellerLeadsApi } from '@/helpers/Api';
import { getAxiosClient } from '@/helpers/Axios/axiosClient';
import { PropertyValuationResult } from '@/models/queries/getPropertyData';
import { PropertyType } from '@/types';
import { User } from '@auth0/auth0-vue';
import { captureError } from '@smg-real-estate/browser-rum';
import { HgSupportedLanguage } from '@smg-real-estate/domus/types';
import { Source } from '@smg-real-estate/seller-leads-schema';
import { ContactRequest } from './types';

export const submitContactForm = async (contactRequestData: ContactRequest): Promise<boolean> => {
  try {
    await getAxiosClient().post(getSellerLeadsApi('contact-request'), contactRequestData);
    return true;
  } catch (e) {
    captureError(e);
    return false;
  }
};

export const mapToContactRequest = (
  contactFormPayload: ContactRequest,
  propertyData?: PropertyValuationResult,
  userInfo?: User,
  source?: Source,
): ContactRequest => {
  return {
    ...(propertyData &&
      source && {
        propertyDetails: {
          id: propertyData.leadId,
          name: userInfo?.name,
          address: `${propertyData.street}, ${propertyData.zipCode} ${propertyData.town}`,
          email: userInfo?.email,
          livingSpace: propertyData.livingSpace,
          priceFixed: propertyData.appraisalPrice,
          priceFrom: propertyData.evaluatedPriceFrom,
          priceTo: propertyData.evaluatedPriceTo,
          rooms: propertyData.room,
          lotSize: propertyData.lotSize,
          type: PropertyType[propertyData.propertyType],
          yearBuild: propertyData.yearBuild,
          renovationYear: propertyData.renovationYear,
          source: source,
        },
      }),
    ...contactFormPayload,
    language: contactFormPayload.language.toUpperCase() as HgSupportedLanguage, //seller leads service requires language capitalized
  };
};
